import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Checkbox, Popover, Space } from 'antd';
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapPin } from '@fortawesome/free-solid-svg-icons/faMapPin';
import { axiosErrorHandler } from "../../../swzutils";
const VehicleTypeCategoryCheckboxGroup = ({ value, onChange, disabled = false, allAvailable = true }) => {
    const [categories, setCategories] = useState([]);
    useEffect(() => {
        loadVehicleTypeCategories();
    }, []);
    const loadVehicleTypeCategories = () => {
        axios.get(`/admin/v1/vehicle-types/categories?allAvailable=${allAvailable}`)
            .then(response => setCategories(response.data))
            .catch(axiosErrorHandler);
    };
    return (_jsx(Checkbox.Group, { disabled: disabled, onChange: onChange, value: value, children: _jsx(Space, { orientation: "vertical", children: categories
                .sort((a, b) => {
                if (a.name > b.name)
                    return 1;
                if (a.name < b.name)
                    return -1;
                return 0;
            })
                .map(it => {
                return (_jsxs(Checkbox, { value: it.name, children: [it.description, it.marketplaceParticipator &&
                            _jsx(Popover, { content: _jsx("p", { children: "Available on marketplace" }), children: _jsx(FontAwesomeIcon, { icon: faMapPin, className: "pull-right", style: { fontSize: '10pt', paddingTop: '3px' } }) })] }, it.name));
            }) }) }));
};
export default VehicleTypeCategoryCheckboxGroup;
